import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import {
	IAssigneeTeam,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AuLogoPlaceholderModule, AuRoundAvatarModule } from '@shared/ui-components';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AssigneeQuickSearchPipe } from '@shared/ui-components/au-assignee-select/pipes/assignee-quick-search.pipe';
import { EmptyPlaceholderComponent } from '@app/shared/ui-components/empty-placeholder/empty-placeholder.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { AssigneeOrganizationOption } from '@shared/ui-components/au-assignee-select/au-assignee-select.types';

@Component({
	selector: 'assignee-options-list',
	templateUrl: './assignee-options-list.component.html',
	styleUrls: ['./assignee-options-list.component.scss'],
	imports: [
		CommonModule,
		MatInputModule,
		FormsModule,
		MatIconModule,
		AuLogoPlaceholderModule,
		MatTooltipModule,
		AuRoundAvatarModule,
		AssigneeQuickSearchPipe,
		EmptyPlaceholderComponent,
		NgxTolgeeModule,
	],
})
export class AssigneeOptionsListComponent {
	@Input() options: AssigneeOrganizationOption[];
	@Input() disableTeamsSelection: boolean;
	@Input() showSelected: boolean;
	@Input() actionCenter: boolean = false;
	@Output() selectionChange = new EventEmitter<IAssigneeTeam | IAssigneeUser>();

	searchText: string;

	selectedOption: IAssigneeTeam | IAssigneeUser;
	index = signal(0);

	selectOption(
		evt: MouseEvent,
		option: IAssigneeTeam | IAssigneeUser,
		type?: 'team' | 'user'
	): void {
		if (this.disableTeamsSelection && type === 'team') {
			evt.stopPropagation();
			return;
		}

		this.selectedOption = option;
		this.selectionChange.emit(option);
	}
}
